import _ from 'lodash'
import dayjs, { Dayjs } from 'dayjs'
import { useMemo, useState } from 'react'

import { getMinutesFromTimeString } from '@/utils/helpers'

import useInterval from './useInterval'

export function useDateTimePickerOptions(defaultStartDate?: Date) {
  const [currentDateTime, setCurrentDateTime] = useState(dayjs())
  const [datePickerValue, setDatePickerValue] = useState<Dayjs | null>(defaultStartDate ? dayjs(defaultStartDate) : dayjs())
  const [timePickerValue, setTimePickerValue] = useState<Dayjs | null>(defaultStartDate ? dayjs(defaultStartDate) : dayjs())

  useInterval(() => {
    setCurrentDateTime(dayjs())
  }, 60 * 1000)

  const timePickerOptions = useMemo(() => {
    let timeInterval = 15 // minutes
    let closingTime = '20:00'
    return _.filter(
      _.range(24 * (60 / timeInterval)).map((time) =>
        dayjs()
          .startOf('day')
          .add(timeInterval * time, 'minutes')
          .format('HH:mm')
      ),
      (timeOption) =>
        dayjs(datePickerValue)
          .startOf('day')
          .add(dayjs.duration(getMinutesFromTimeString(timeOption), 'minutes').asMilliseconds(), 'milliseconds')
          .isBetween(
            currentDateTime,
            dayjs(datePickerValue)
              .startOf('day')
              .add(dayjs.duration(getMinutesFromTimeString(closingTime), 'minutes').asMilliseconds(), 'milliseconds'),
            undefined,
            '(]'
          )
    )
  }, [currentDateTime, datePickerValue])

  return {
    currentDateTime,
    datePickerValue,
    setDatePickerValue,
    timePickerValue,
    setTimePickerValue,
    timePickerOptions,
  }
}
